
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/polityka-prywatnosci",
      function () {
        return require("private-next-pages/polityka-prywatnosci.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/polityka-prywatnosci"])
      });
    }
  